import React from 'react';
import PropTypes from 'prop-types';
import ListShowMoreWrapper from '../ListShowMoreWrapper';
import {
  StyledBarAmountList,
  StyledBarAmountListItem,
  StyledBarAmountListItemSpace,
  StyledBarAmountListItemWrapper,
  StyledBarAmountListItemName,
  StyledBarAmountListItemValue,
  StyledBarAmountProgress
} from './StyledBarAmountList';
import {amountHelpers} from '../../../utils/helpers';
import {colorsStyles} from '../../../utils/styles';


const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.35 } },
  exit: { opacity: 0, y: -24, transition: { duration: 0.2 } }
};

const BarAmountList = ({ items, maxVisible = 4, onItemClick, ...rest }) => {
  return (
    <StyledBarAmountList {...rest}>
      <ListShowMoreWrapper
        items={items}
        maxVisible={maxVisible}
        itemVariants={itemVariants}
        renderContent={({ item = {} }) => {
          const {actual, expected} = item;
          const fillPercent = (actual / expected * 100).toFixed(2);
          return (
            <StyledBarAmountListItemSpace
              direction='vertical'
              onClick={(e) => onItemClick?.(e, item)}
              size={4}
              style={{ width: '100%' }}
            >
              <StyledBarAmountListItemWrapper>
                <StyledBarAmountListItemName>{item.name}</StyledBarAmountListItemName>
                <StyledBarAmountListItemValue>{amountHelpers.getAmountWithCurrencyCode(item?.actual)}</StyledBarAmountListItemValue>
              </StyledBarAmountListItemWrapper>
              <StyledBarAmountProgress
                strokeColor={actual > expected ? colorsStyles.functional_danger : colorsStyles.neutral_8}
                percent={fillPercent}
                showInfo={false}
              />
            </StyledBarAmountListItemSpace>
          )
        }}
        itemKey={item => item.name}
        itemClass={StyledBarAmountListItem}
      />
    </StyledBarAmountList>
  );
};

BarAmountList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      actual: PropTypes.number,
      expected: PropTypes.number,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  maxVisible: PropTypes.number,
  onItemClick: PropTypes.func,
};

export default BarAmountList;
